// https://gitlab.ord.metapeer.com/mfc/mfc-www-react/-/issues/949
export const sentryIgnoreList = [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    'window.bannerNight is not a function',
    "Can't find variable: QK_middlewareReadModePageDetect",
    '__tv_keydown is not defined',
    'ibFindAllVideos is not defined',
    'tgetT is not defined',
    "Can't find variable: setIOSParameters",
    'privateSpecialRepair is not defined',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // Network Errors / Timeouts / Cancellations / Interruptions
    // https://sentry.io/organizations/yourorg/issues/2455549431/?project=5223179
    'cancelado',
    'geannuleerd',
    'cancelled',
    'TypeError: cancelled',
    '已取消',
    'annulé',
    // https://sentry.io/organizations/yourorg/issues/2677965577/?project=5223179
    'отменено',
    'TypeError: NetworkError when attempting to fetch resource.',
    'NetworkError',
    // https://sentry.io/organizations/yourorg/issues/2460899013/events/?project=5223179 ('Network interruption')
    '网络连接已中断',
    // https://sentry.io/organizations/yourorg/issues/2634300273/activity/?project=5223179
    '似乎已断开与互联网的连接',
    // https://sentry.io/organizations/yourorg/issues/2668132627/activity/?project=5223179
    'Вероятно, соединение с интернетом прервано',
    // https://sentry.io/organizations/yourorg/issues/2670865980/activity/?project=5223179
    'Превышен лимит времени на запрос.',
    // https://sentry.io/organizations/yourorg/issues/2669236737/?project=5223179
    'Se ha agotado el tiempo de espera.',
    // https://sentry.io/organizations/yourorg/issues/2437608108/events/?project=5223179
    'Failed to fetch',
    '$ is not defined',
    'videojs is undefined',
    // https://sentry.io/organizations/yourorg/issues/2475429300/activity/?project=5223179
    'A bad HTTP response code (403) was received when fetching the script.',
    // https://sentry.io/organizations/yourorg/issues/2431924824/activity/?project=5223179
    'ResizeObserver loop limit exceeded',
    // https://sentry.io/organizations/yourorg/issues/2437110279/activity/?project=5223179
    'InvalidStateError: The object is in an invalid state.',
    // Sentry bug - https://sentry.io/organizations/yourorg/issues/2459826993/
    // https://github.com/getsentry/sentry-javascript/issues/2292
    'Non-Error exception',
    // https://sentry.io/organizations/yourorg/issues/2437369043/?project=5223179&statsPeriod=14d
    'missing email',
    'missing username',
    'missing password',
    // https://sentry.io/organizations/yourorg/issues/3630816186/?project=5223179&query=is%3Aunresolved&statsPeriod=14d
    "'username' is required!",
    // https://sentry.io/organizations/yourorg/issues/3638223204/?project=5223179&query=is%3Aunresolved&statsPeriod=14d
    "'note' is required!",
    // Network Connection lost
    // https://sentry.io/organizations/yourorg/issues/2459649089/?project=5223179&query=is%3Aignored&sort=freq&statsPeriod=14d
    'The network connection was lost.',
    '请求超时。',
    // https://sentry.io/organizations/yourorg/issues/2672732844/?project=5223179
    'La conexión a internet parece estar desactivada.',
    // firefox bug
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1507193
    'AbortError: The operation was aborted.',
    // MFC specific errors - safe to ignore
    // sharpie.js
    "null is not an object (evaluating 'this.container.classList')",
    // https://sentry.io/organizations/yourorg/issues/2437331346/?project=5223179&query=is%3Aignored&sort=freq&statsPeriod=14d
    "Cannot read property 'classList' of null",
    // VideoPlayer
    "null is not an object (evaluating 'this.el_[e]')",
    "null is not an object (evaluating 'this.el_[t]=e')",
    "Cannot read property 'code' of null",
    // Edge Mobile bug - https://sentry.io/organizations/yourorg/issues/2572780064/activity/?project=5223179&query=is%3Aunresolved
    "Can't find variable: instantSearchSDKJSBridgeClearHighlight",
    // https://sentry.io/organizations/yourorg/issues/2656277849/activity/?project=5223179&statsPeriod=14d
    'Сертификат для данного сервера недействителен. Возможно, Вы подключаетесь к серверу, имитирующему «www.myfreecams.com», что может подвергнуть риску Вашу конфиденциальную информацию.',
    // SSL Related (usually if device time is incorrect)
    // https://sentry.io/organizations/yourorg/issues/2669215948/?project=5223179
    '发生了SSL错误，无法建立与该服务器的安全连接',
    'Se ha producido un error de SSL y no puede establecerse una conexión segura con el servidor.',
    // https://sentry.io/organizations/yourorg/issues/2663213891/?project=5223179&query=is%3Aignored&sort=freq&statsPeriod=14d
    'Произошла ошибка SSL. Безопасное подключение к серверу невозможно',
    // UC Browser - https://sentry.io/organizations/yourorg/issues/2572780064/?project=5223179&query=is%3Aignored&statsPeriod=14d
    'UC_NEWS_PAUSE_ALL_VIDEOS',
    "Can't find variable: UC_NEWS_PAUSE_ALL_VIDEOS",
    // UC Browser - https://sentry.io/organizations/yourorg/issues/2541567540/?project=5223179&query=is%3Aignored&statsPeriod=14d
    'UCShellJava.sdkEventFire is not a function',
    // the following may be due to bots
    // https://sentry.io/organizations/yourorg/issues/3491435735/?project=5223179&query=is%3Aignored&statsPeriod=14d
    // https://sentry.io/organizations/yourorg/issues/3629151426/?project=5223179&query=is%3Aunresolved&statsPeriod=14d
    "Can't find variable: JSBridge",
    // https://sentry.io/organizations/yourorg/issues/3658339474/?project=5223179&query=is%3Aignored
    'runCustomize is not defined',
    // https://sentry.io/organizations/yourorg/issues/3658339483/?project=5223179&query=is%3Aignored
    'processRandomSelector is not defined',
    // https://sentry.io/organizations/yourorg/issues/3258879147/?project=5223179&query=is%3Aignored&statsPeriod=14d
    'window.appHotStart is not a function',
    // something eth related - https://sentry.io/organizations/yourorg/issues/2462801193/events/a01b843c41ec4a90b4f1a92634f3926e/?project=5223179&statsPeriod=14d
    "undefined is not an object (evaluating 'window.ethereum.selectedAddress = undefined')",
    // user interactions
    // https://sentry.io/organizations/yourorg/issues/3484807655/?project=5223179&query=is%3Aunresolved
    'AbortError: The play() request was interrupted because a pause was requested by the user. https://goo.gl/LdLk22',
    // https://sentry.io/organizations/yourorg/issues/2942033716/?project=5223179&query=is%3Aignored
    // https://sentry.io/organizations/yourorg/issues/3651792587/?project=5223179&query=is%3Aunresolved&statsPeriod=14d
    "The fetching process for the media resource was aborted by the user agent at the user's request.",
    // https://sentry.io/organizations/yourorg/issues/3496471885/?project=5223179&query=is%3Aunresolved
    'AbortError: The play() request was interrupted because video-only background media was paused to save power. https://goo.gl/LdLk22',
    // https://sentry.io/organizations/yourorg/issues/2997702772/?project=5223179&query=is%3Aunresolved&statsPeriod=14d
    // https://sentry.io/organizations/yourorg/issues/3644451424/?project=5223179&query=is%3Aunresolved&statsPeriod=14d
    'The play method is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.',
    // https://sentry.io/organizations/yourorg/issues/3657689752/?project=5223179&query=is%3Aunresolved&statsPeriod=14d
    'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.',
    // general filtering
    'AbortError',
    'NotAllowedError',
    'NotSupportedError',
    "Can't find variable: $",
    'VideoPlayer',
    'VideoPublisher',
    "Failed to read the 'buffered' property from 'SourceBuffer'",
    'Load Failed',
    "Failed to set the 'playbackRate' property on 'HTMLMediaElement'",
    "Uncaught InvalidStateError: Failed to execute 'send' on 'WebSocket'",
    "undefined is not an object (evaluating 'window.webkit.messageHandlers')",
    'Fullscreen request denied',
    'Browser does not support any of the required codecs',
    // https://yourorg.sentry.io/issues/2437489559/?project=5223179
    'unlabeled event',
]

// need to update sentry (and in turn upgrade nextjs to 10.0.8) to use; adding until then
export const sentryUrlsToIgnore = [
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
]

export const enum ErrorReportingEnums {
    error_page = 'error page',
    fetch = 'fetch',
    init = 'init',
    navigation = 'navigation',
    ssr = 'server side render',
    user = 'user',
}

/**
 * Importing from Sentry; they marked this as deprecated but we use levels a lot
 * https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/severity.ts
 */
export enum SentrySeverity {
    Fatal = 'fatal',
    Error = 'error',
    Warning = 'warning',
    Log = 'log',
    Info = 'info',
    Debug = 'debug',
}
